const riskAversion = () => import('../../pages/riskAversion/index.vue')
const details = () => import('../../pages/riskAversion/details.vue')
const badRecord = () => import('../../pages/riskAversion/badRecord.vue')
export default [
  {
    path: '/riskAversion',
    name: '风险规避',
    component: riskAversion,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/riskAversion/details',
    name: '详情',
    component: details,
    meta: {
      headerShow: true,
      footerShow: true,
      sidebarShow: false,
    }
  },
  {
    path: '/riskAversion/badRecord',
    name: '不良纪律',
    component: badRecord,
    meta: {
      headerShow: true,
      footerShow: true,
      sidebarShow: false,
    }
  }
]


// WEBPACK FOOTER //
// ./src/router/modules/riskAversionRouter.js